module.exports = __webpack_public_path__ + "static/1165575988.dcc93517.jpg";